import React, { useState, useRef, useEffect } from 'react';
import * as d3 from 'd3';
import '../styles/Charts.css';

const ChartDonut = ({dataProps1, dataProps2}) => {
    // preset data if data props not given
    const [dataDonut1, updateDataDonut1] = useState([
        {property: 'Enrollment', value: 30},
        {property: 'Transfer', value: 70},
        {property: 'Completion of grade', value: 92}
    ]) 
    
    const [dataDonut2, updateDataDonut2] = useState([
        {property: 'Personal Identification', value: 44},
        {property: 'Academic Records', value: 64},
        {property: 'Financial', value: 79}
    ])

    const data1 = dataProps1 || dataDonut1;
    const data2 = dataProps2 || dataDonut2;

    const svgRef = useRef();

    // Attributes of the chart
    const width = 200;
    const height = 200;
    const radius = Math.min(width, height) / 2;
    
    useEffect(()=>{
        if (!data1 || data1.length === 0 || !data2 || data2.length === 0) return;

        const svg = d3.select(svgRef.current)
            .attr('width', width)
            .attr('height', height)
            .append('g')
            .attr('transform', `translate(${width / 2}, ${height / 2})`);

        const colorCustom = ["#404040","#606060","#808080","#c0c0c0","#e0e0e0","#f0f0f0","#ffffff"]
        const colorScale = d3.scaleOrdinal(colorCustom);

        const pie = d3.pie()
            .value(d => d.value)
            .sort(null);

        const arcInner = d3.arc()
            .innerRadius(radius * 0.4)
            .outerRadius(radius * 0.7);

        const arcOuter = d3.arc()
            .innerRadius(radius * 0.6)
            .outerRadius(radius * 0.8);

        const pieData1 = pie(data1);
        const pieData2 = pie(data2);

        // Draw inner arcs
        svg.selectAll('.inner-arc')
            .data(pieData1)
            .enter()
            .append('path')
            .attr('class', 'inner-arc')
            .attr('d', arcInner)
            .attr('fill', (d, i) => colorScale(i + data1.length))
            .attr('stroke', 'white')
            .attr('stroke-width', 2);

        // Draw outer arcs
        svg.selectAll('.outer-arc')
            .data(pieData2)
            .enter()
            .append('path')
            .attr('class', 'outer-arc')
            .attr('d', arcOuter)
            .attr('fill', (d, i) => colorScale(i))
            .attr('stroke', 'white')
            .attr('stroke-width', 2);

        // Create legend labels above chart
        const labelsArea = d3.select('#labelsDonut');
        labelsArea.selectAll('*').remove();
            
        // Data labels on chart itself
        svg.selectAll('.inner-label')
            .data(pieData1)
            .enter()
            .append('text')
            .attr('class', 'label')
            .attr('transform', d => `translate(${arcInner.centroid(d)})`)
            .attr('dy', '0.35em')
            .text(d => d.data.value)
            .attr('class', 'text-label');

        svg.selectAll('.outer-label')
            .data(pieData2)
            .enter()
            .append('text')
            .attr('class', 'label')
            .attr('transform', d => `translate(${arcOuter.centroid(d)})`)
            .attr('dy', '0.35em')
            .text(d => d.data.value)
            .attr('class', 'text-label');

        // Create legend for data
        const combinedData = [...data1, ...data2];

        const labelDivs = labelsArea.selectAll('div')
            .data(combinedData)
            .enter()
            .append('div')
            .attr('class', 'label-container');
    
        labelDivs.append('div')
            .attr('class', 'color-circle')
            .style('background-color', (d, i) => colorCustom[i % colorCustom.length]);
    
        labelDivs.append('span')
            .text(d => `${d.property}`)
            .attr('class', 'text-legend')
            ;

        return () => {
            d3.select(svgRef.current).selectAll('g').remove(); // Cleanup on unmount or data change
        };
    }, [data1, data2]);

    return (
        <div>
            <article id='labelsDonut'>
                {/* data legend will be here */}
            </article>
            <svg
            ref={svgRef}
            width={width}
            height={height}            
            >
            </svg>
        </div>
    )
}

export default ChartDonut